<template>
    <Hakodate></Hakodate>
</template>

<script>
import Hakodate from '@/components/Organisms/Hakodate'

export default {
  name: 'p-Hakodate',
  components: {
    Hakodate
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Hakodate/index.vue